import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var workingStatusApiCalls = {
  fetchWorkingStatuses: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.GET_WORKINGSTATUSES_REQUEST, ActionTypes.GET_WORKINGSTATUSES_SUCCESS, ActionTypes.GET_WORKINGSTATUSES_FAILURE, ActionTypes.RESET_GET_WORKINGSTATUSES]
  })
};
export default workingStatusApiCalls;